import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type OnboardingInfoCardBadgeColor = 'pink' | 'purple' | 'orange' | 'green';

@Component({
  selector: 'app-onboarding-info-card',
  imports: [],
  templateUrl: './onboarding-info-card.component.html',
  styleUrl: './onboarding-info-card.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingInfoCardComponent {
  readonly badgeColor = input<OnboardingInfoCardBadgeColor>('purple');
}
